











































import { Vue, Component, Prop } from "vue-property-decorator";
import VoteBanListModal from "@/pages/showDetail/VoteBanListModal.vue";

@Component({
  components: {
    "ban-list-modal": VoteBanListModal
  }
})
export default class VoteList extends Vue {
  @Prop({ required: true })
  dataList!: Array<Object>;

  showModal: boolean = false;
  chooseItem: any = {};

  // 打开解冻Modal
  handleShowModal(chooseItem: any) {
    this.chooseItem = chooseItem;
    this.showModal = true;
  }

  handleCloseModal(refresh: boolean) {
    if (refresh) {
      this.$emit("refresh");
    }
    this.chooseItem = {};
    this.showModal = false;
  }
}
